module.exports = __webpack_public_path__ + "img/bell-ring.65570ae4.png";